// ---------- Anonymous per-reading purchase flow (Quiromancia) ----------
// Mismo patrón que suenos: el usuario llena el form, se crea la HandReading
// pendiente (sin contenido) y se arranca el checkout. Al volver con session_id
// (Stripe) o paypal=1&token= (PayPal), verify materializa la compra y arma la
// entrega server-side. La lectura llega luego por correo (revisión humana 24h).

export const CREATE_PENDING_REQUEST = 'QUIROMANCIA/CREATE_PENDING_REQUEST';
export const createPendingRequest = ({ email, name, features, handImage }) =>
  ({ type: CREATE_PENDING_REQUEST, payload: { email, name, features, handImage } });
export const CREATE_PENDING_SUCCESS = 'QUIROMANCIA/CREATE_PENDING_SUCCESS';
export const createPendingSuccess = (readingId) =>
  ({ type: CREATE_PENDING_SUCCESS, payload: { readingId } });
export const CREATE_PENDING_FAILURE = 'QUIROMANCIA/CREATE_PENDING_FAILURE';
export const createPendingFailure = (error) =>
  ({ type: CREATE_PENDING_FAILURE, payload: error });

export const CHECKOUT_REQUEST = 'QUIROMANCIA/CHECKOUT_REQUEST';
export const quiromanciaCheckoutRequest = (email, readingId) =>
  ({ type: CHECKOUT_REQUEST, payload: { email, reading_id: readingId } });
export const CHECKOUT_SUCCESS = 'QUIROMANCIA/CHECKOUT_SUCCESS';
export const quiromanciaCheckoutSuccess = () => ({ type: CHECKOUT_SUCCESS });
export const CHECKOUT_FAILURE = 'QUIROMANCIA/CHECKOUT_FAILURE';
export const quiromanciaCheckoutFailure = (e) => ({ type: CHECKOUT_FAILURE, payload: e });

export const PAYPAL_REQUEST = 'QUIROMANCIA/PAYPAL_REQUEST';
export const quiromanciaPaypalOrderRequest = (email, readingId) =>
  ({ type: PAYPAL_REQUEST, payload: { email, reading_id: readingId } });
export const PAYPAL_SUCCESS = 'QUIROMANCIA/PAYPAL_SUCCESS';
export const quiromanciaPaypalOrderSuccess = () => ({ type: PAYPAL_SUCCESS });
export const PAYPAL_FAILURE = 'QUIROMANCIA/PAYPAL_FAILURE';
export const quiromanciaPaypalOrderFailure = (e) => ({ type: PAYPAL_FAILURE, payload: e });

export const VERIFY_REQUEST = 'QUIROMANCIA/VERIFY_REQUEST';
export const quiromanciaVerifyPurchaseRequest = (sessionId) =>
  ({ type: VERIFY_REQUEST, payload: { session_id: sessionId } });
export const VERIFY_SUCCESS = 'QUIROMANCIA/VERIFY_SUCCESS';
export const quiromanciaVerifyPurchaseSuccess = (data) =>
  ({ type: VERIFY_SUCCESS, payload: data });
export const VERIFY_FAILURE = 'QUIROMANCIA/VERIFY_FAILURE';
export const quiromanciaVerifyPurchaseFailure = (e) => ({ type: VERIFY_FAILURE, payload: e });

export const VERIFY_PAYPAL_REQUEST = 'QUIROMANCIA/VERIFY_PAYPAL_REQUEST';
export const quiromanciaVerifyPaypalRequest = (paypalOrderId) =>
  ({ type: VERIFY_PAYPAL_REQUEST, payload: { paypal_order_id: paypalOrderId } });
export const VERIFY_PAYPAL_SUCCESS = 'QUIROMANCIA/VERIFY_PAYPAL_SUCCESS';
export const quiromanciaVerifyPaypalSuccess = (data) =>
  ({ type: VERIFY_PAYPAL_SUCCESS, payload: data });
export const VERIFY_PAYPAL_FAILURE = 'QUIROMANCIA/VERIFY_PAYPAL_FAILURE';
export const quiromanciaVerifyPaypalFailure = (e) => ({ type: VERIFY_PAYPAL_FAILURE, payload: e });
